<div class="modals__container">
  <div class="modals__header">
    <img
      mfpLazyImage
      class="modals__close"
      lazySrc="assets/icons/close.svg"
      (click)="close()"
    />
  </div>
  <div class="financial-info">
    <h1 class="financial-info__title">{{ 'FINANCIAL_INFO.TITLE' | translate }}</h1>
    <div class="financial-info__info">
      <mfp-circular-indicator [basePercentage]="ratings.financial.default" [currentPercentage]="ratings.financial.current"></mfp-circular-indicator>
      <p class="info__paragraph">{{'LIFE_CICLE.INFO.SITUATION' | translate}}</p>
    </div>

    <div class="financial-info__features grid">
      <mfp-financial-card
        type="amount"
        [title]="'FINANCIAL_INFO.FEATURES.MONTHLY_INCOMES.TITLE' | translate"
        [text]="'FINANCIAL_INFO.FEATURES.MONTHLY_INCOMES.DESCRIPTION' | translate"
        [amount]="financialInfoData.features.monthlyIncomes.currencyAmount.amount"
        [currency]="getCurrencyKey(financialInfoData.features.monthlyIncomes.currencyAmount.currency, currencyOptions) "
      ></mfp-financial-card>

      <mfp-financial-card
        type="percentage"
        [title]="'FINANCIAL_INFO.FEATURES.MONTHLY_EXPENSES.TITLE' | translate"
        [text]="'FINANCIAL_INFO.FEATURES.MONTHLY_EXPENSES.DESCRIPTION' | translate"
        [percentage]="financialInfoData.features.monthlyExpenses.percentage"
      ></mfp-financial-card>

      <mfp-financial-card
        type="chart"
        [title]="'FINANCIAL_INFO.FEATURES.SAVING_CAPACITY.TITLE' | translate"
        [text]="'FINANCIAL_INFO.FEATURES.SAVING_CAPACITY.HELPER' | translate"
        [percentage]="financialInfoData.features.savingCapacityChart.percentage"
        [bar1]="{
          title: 'FINANCIAL_INFO.FEATURES.INCOMES' | translate,
          amount: financialInfoData.features.savingCapacityChart.incomes.amount,
          currency: getCurrencyKey(financialInfoData.features.savingCapacityChart.incomes.currency, currencyOptions),
          height: 80
        }"
        [bar2]="{
          title: 'FINANCIAL_INFO.FEATURES.EXPENSES' | translate,
          amount: financialInfoData.features.savingCapacityChart.expenses.amount,
          currency: getCurrencyKey(financialInfoData.features.savingCapacityChart.expenses.currency, currencyOptions),
          height: 40
        }"
      ></mfp-financial-card>

      <mfp-financial-card
        type="percentage"
        [title]="'FINANCIAL_INFO.FEATURES.SAVING_CAPACITY.TITLE' | translate"
        [text]="'FINANCIAL_INFO.FEATURES.SAVING_CAPACITY.DESCRIPTION' | translate"
        [percentage]="financialInfoData.features.savingCapacity.percentage"
      ></mfp-financial-card>

      <mfp-financial-card
        type="amount"
        [title]="'FINANCIAL_INFO.FEATURES.OTHER_INCOMES.TITLE' | translate"
        [text]="'FINANCIAL_INFO.FEATURES.OTHER_INCOMES.DESCRIPTION' | translate"
        [amount]="financialInfoData.features.otherIncomes.currencyAmount.amount"
        [currency]="getCurrencyKey(financialInfoData.features.otherIncomes.currencyAmount.currency, currencyOptions)"
      ></mfp-financial-card>
    </div>

    <h2 class="financial-info__recommendations-title">{{ 'FINANCIAL_INFO.RECOMMENDATIONS_TITLE' | translate }}</h2>
    <div class="financial-info__recommendations grid">
      <div class="recommendations__card-info mfp-gray-box">
        <img
          mfpLazyImage
          class="mfp-gray-box__image recommendations__card-info-icon"
          lazySrc="assets/icons/info-gray.svg"
        />
        <p class="recommendations__card-info__text">{{ 'FINANCIAL_INFO.RECOMMENDATIONS.0' | translate }}</p>
      </div>
      <div class="recommendations__card-info mfp-gray-box">
        <img
          mfpLazyImage
          class="mfp-gray-box__image recommendations__card-info-icon"
          lazySrc="assets/icons/info-gray.svg"
        />
        <p class="recommendations__card-info__text">{{ 'FINANCIAL_INFO.RECOMMENDATIONS.1' | translate }}</p>
      </div>
      <div class="recommendations__card-info mfp-gray-box">
        <img
          mfpLazyImage
          class="mfp-gray-box__image recommendations__card-info-icon"
          lazySrc="assets/icons/info-gray.svg"
        />
        <p class="recommendations__card-info__text">{{ 'FINANCIAL_INFO.RECOMMENDATIONS.2' | translate }}</p>
      </div>
    </div>
  </div>
</div>
